import React from 'react';
import { clsx } from 'clsx';

export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={clsx('animate-pulse rounded', className)}
      style={{ background: 'var(--tg-border)' }}
    />
  );
}
